import React from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { contentListService } from '../../../services/cms/contentManagementService';
import ListItemsPicker from './components/ListItemsPicker';

const { Text } = Typography;

const TYPE_OPTIONS = [
  { label: 'Bài viết', value: 1 },
  { label: 'Danh mục', value: 2 },
  { label: 'Sự kiện', value: 3 },
  { label: 'Danh mục sự kiện', value: 4 },
  { label: 'Thể loại sự kiện', value: 5 },
  { label: 'Đối tượng', value: 6 },
  { label: 'Thể loại đối tượng', value: 7 },
  { label: 'Ảnh', value: 8 },
  { label: 'Video', value: 9 },
  { label: 'Thiệp', value: 10 },
  { label: 'Danh ngôn', value: 11 },
  { label: 'Thành viên', value: 12 },
  { label: 'Premium type', value: 13 },
];

const filterFields = [
  {
    label: 'Chọn thể loại',
    value: 'item_type',
    options: [{ label: 'Tất cả thể loại', value: '' }, ...TYPE_OPTIONS],
  },
];

// Giống form Danh sách của CMS cũ: chọn loại item → tìm & thêm item → sửa thứ tự / xoá.
const formFields = [
  { name: 'title', label: 'Tên danh sách', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập!' }] },
  // list.item_type và list.items đều NOT NULL không default (QA-10). Giá trị của ô Items là
  // mảng { id, order } do ListItemsPicker trả về (mapFormToData mới đổi sang JSON) nên rule
  // phải là type: 'array' — `required` đơn thuần không bắt được mảng rỗng.
  { name: 'item_type', label: 'Loại item', type: 'select', options: TYPE_OPTIONS, defaultValue: 1, rules: [{ required: true, message: 'Vui lòng chọn loại item!' }] },
  { name: 'items', label: 'Items', type: 'custom', rules: [{ required: true, type: 'array', min: 1, message: 'Vui lòng chọn ít nhất một item!' }], render: ({ value, onChange }) => <ListItemsPicker value={value} onChange={onChange} /> },
];

// DB lưu items = JSON mảng id (đã sort theo thứ tự) — giữ format để app/CMS cũ đọc chung
const parseItems = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (!raw) return [];
  try {
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch (e) {
    return [];
  }
};
const mapDataToForm = (record) => ({
  items: parseItems(record?.items).map((id, idx) => ({ id: Number(id), order: idx + 1 })),
});
const mapFormToData = (payload) => {
  const list = Array.isArray(payload.items) ? payload.items : [];
  const sorted = [...list].sort((a, b) => (Number(a.order) || 0) - (Number(b.order) || 0));
  return { ...payload, items: sorted.length ? JSON.stringify(sorted.map((it) => Number(it.id))) : '' };
};

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TÊN', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  { title: 'LOẠI', dataIndex: 'item_type', key: 'item_type', width: 150, render: (t) => {
    const found = TYPE_OPTIONS.find(o => o.value === t);
    return found ? found.label : t;
  }},
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 140, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'NGÀY TẠO', dataIndex: 'create_time', key: 'create_time', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyDanhSach = () => (
  <CrudPage title="QUẢN LÝ DANH SÁCH" subTitle="Quản lý danh sách nội dung" itemsName="Danh sách" queryKey="contentListList" service={contentListService} columns={columns} formFields={formFields} filterFields={filterFields} mapDataToForm={mapDataToForm} mapFormToData={mapFormToData} searchPlaceholder="Tìm kiếm..." addButtonLabel="Thêm danh sách" />
);
export default QuanLyDanhSach;
